export default __webpack_public_path__ + "static/media/instagram.944e099d.svg";